<template>
    <FileLoading
        v-if="isLoadingAddFileForm"
        class="h-[50vh]"
    />
    <div v-show="!isLoadingAddFileForm">
        <slot />
    </div>
    <EditAvailableClientSheet
        v-model:open="isEditClientSheetOpen"
        :clientValue="clientValueBeingEdited"
    />
    <DsToast class="md:top-16" />
</template>

<script setup lang="ts">
import { useAddFileStore } from '@/company-portal/add-file/add-file.store';
import type { MultipleSelectClient } from '@/company-portal/add-file/add-file.types';
import DsToast from '@/components/design-system/toast/DsToast.vue';
import EditAvailableClientSheet from '@/components/Views/Company/AddFile/EditClient/EditAvailableClientSheet.vue';
import FileLoading from '@/components/Views/Company/File/FileLoading.vue';
import { EDIT_AVAILABLE_CLIENT_SHEET_INJECTION_KEY } from '@/injection-keys';
import { useUserStore } from '@/stores/company/user.store';
import { computed, provide, ref } from 'vue';

const userStore = useUserStore();

userStore.getActiveCompanies();
userStore.getActiveBranches();
userStore.getAvailableWireDocs();

const isLoadingAddFileForm = computed(
    () =>
        userStore.isFetchingMeDetail ||
        userStore.isFetchingCompanies ||
        userStore.isFetchingBranches ||
        userStore.isFetchingWireDocs,
);

const props = defineProps<{
    tpsOrderJsonString: string;
}>();

useAddFileStore().ingestTpsOrder(props.tpsOrderJsonString);

const isEditClientSheetOpen = ref(false);
const clientValueBeingEdited = ref<MultipleSelectClient['value']>();

provide(EDIT_AVAILABLE_CLIENT_SHEET_INJECTION_KEY, {
    editAvailable: true,
    openEditClientSheet: (clientValue: MultipleSelectClient['value']) => {
        clientValueBeingEdited.value = clientValue;
        isEditClientSheetOpen.value = true;
    },
});
</script>
